import { FaUsers } from "react-icons/fa";
import { FaHandshake } from "react-icons/fa6";
import { GiLaurelsTrophy } from "react-icons/gi";
import { MdEventNote } from "react-icons/md";
import { BiSolidBook } from "react-icons/bi";
import { useGetSnapshotData } from "../../queries/dashboard";
import Loading from "./Loading";
import Section from "./Section";

const Snapshot = () => {

    const { data, isPending } = useGetSnapshotData();

    const snapshotData = {
        totalUsers: {
            active: data?.users?.activeUsers,
            total: data?.users?.totalUsers
        },
        totalPartners: {
            active: data?.partners?.activePartners,
            total: data?.partners?.totalPartners
        },
        totalChallenges: {
            active: data?.challenges?.activeChallenges,
            total: data?.challenges?.totalChallenges
        },
        totalEvents: {
            active: data?.events?.activeEvents,
            total: data?.events?.totalEvents
        },
        totalBlogs: {
            active: data?.blogs?.activeBlogs,
            total: data?.blogs?.totalBlogs
        }
    };

    const StatCard = ({ title, active, total, icon }) => (
        <div className='bg-white shadow border border-primaryBg rounded-lg p-5 flex-1 min-w-[200px]'>
            <div className='flex items-center justify-between mb-2'>
                <h3 className='text-xl font-extrabold text-primary'>{title}</h3>
                {icon && <span className='text-2xl'>{icon}</span>}
            </div>
            <div className='flex items-end text-2xl font-bold text-primary'>
                {active}/
                <p className="text-secondary text-base mb-1.5">
                    {total}
                </p>
            </div>
            <div className='text-sm text-secondary'>
                Active: {active} | Total: {total}
            </div>
        </div>
    );

    return (
        <Section
            title={"Snapshot"}
            isLoading={isPending}
            gridCols={3}
        >
            <StatCard
                title="Users"
                active={snapshotData.totalUsers.active}
                total={snapshotData.totalUsers.total}
                icon={<FaUsers className="text-primary" />}
            />
            <StatCard
                title="Partners"
                active={snapshotData.totalPartners.active}
                total={snapshotData.totalPartners.total}
                icon={<FaHandshake className="text-primary" />}
            />
            <StatCard
                title="Challenges"
                active={snapshotData.totalChallenges.active}
                total={snapshotData.totalChallenges.total}
                icon={<GiLaurelsTrophy className="text-primary" />}
            />
            <StatCard
                title="Events"
                active={snapshotData.totalEvents.active}
                total={snapshotData.totalEvents.total}
                icon={<MdEventNote className="text-primary" />}
            />
            <StatCard
                title="Blogs"
                active={snapshotData.totalBlogs.active}
                total={snapshotData.totalBlogs.total}
                icon={<BiSolidBook className="text-primary" />}
            />
        </Section>
    );
};

export default Snapshot;